module.exports = {
  path: '',
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/accounts'),
        require('./routes/carparks'),
        require('./routes/parkings'),
        require('./routes/workspaces'),
      ]);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MainApp'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/index.js